export const settingsNumberFields = {
  BANNER_POSITION: true,
  DISH_FAT_CRITICAL_PERCENT: true,
  DISH_PROTEIN_GOOD_PERCENT: true,
  MACRO_TOLERANCE_MIN: true,
  MACRO_TOLERANCE_MAX: true,
  MAX_GPT_ATTEMPTS: true,
};

export const settingsCheckboxFields = {
  WITH_COHORTS: true,
  REQUIRE_MACRO_RATIO: true,
};

export const settingsDropdownFields = {
  GPT_MODEL: [{
    label: 'GPT-4o',
    value: 'gpt-4o-2024-08-06',
  }, {
    label: 'GPT-5',
    value: 'gpt-5-2025-08-07',
  }],
};

export const settingsExcludedFields = {
  GPT_MODEL: true,
};